/* eslint-disable import/no-default-export */
// eslint-disable-next-line no-restricted-imports
import * as Unsplash from 'types/unsplash';
import * as UnsplashSDK from 'unsplash-js/dist/unsplash';

export type GetCollectionPhotos = (
  id: number,
  page?: number,
  perPage?: number,
  orderBy?: 'latest' | 'popular' | 'oldest',
) => Promise<Unsplash.Photo[]>;

class UnsplashClient {
  appId = '454087647775b190c574339cb2994716b17ef2f83ad11838d0ef0dac2d102e66';
  api = new UnsplashSDK.default({ applicationId: this.appId });
  constants = {
    DEFAULT_COLLECTION_ID: 317099,
    PAGE_SIZE: 18,
    RAW_PARAMS: {
      w: 2560,
      h: 2048,
      q: 90,
    },
    ATTRIBUTION_LINK_TRACKING: {
      utm_source: 'trello',
      utm_medium: 'referral',
      utm_campaign: 'api-credit',
    },
  };

  toJson = UnsplashSDK.toJson;

  parseUserLink = (link: string) => {
    const url = new URL(link);
    url.protocol = 'https:';

    for (const [key, value] of Object.entries(
      this.constants.ATTRIBUTION_LINK_TRACKING,
    )) {
      url.searchParams.append(key, value);
    }

    return url.toString();
  };

  // Gotta wait for TS 3.0, webpack errors on the args
  // getCollectionPhotos: GetCollectionPhotos = (...args) =>
  //   this.api.collections.getCollectionPhotos(...args).then(UnsplashSDK.toJson);
}

export default new UnsplashClient();



// WEBPACK FOOTER //
// ./app/gamma/src/api/unsplash-client.ts